import React from "react";
import PropTypes from "prop-types";
import { classNames } from "../../utils/helpers";

const Badge = (props) => {
  const {
    count = 0,
    children,
    variant = "primary",
    maxCount = 99,
    showZero = false,
    className = "",
    badgeClassName = "",
  } = props;

  const shouldShow = count > 0 || showZero;

  const variantStyles = {
    primary: "bg-blue-500 text-white",
    secondary: "bg-gray-500 text-white",
    success: "bg-green-500 text-white",
    danger: "bg-red-500 text-white",
    warning: "bg-yellow-500 text-black",
    outline: "bg-white text-gray-700 border border-gray-300",
  };

  return (
    <div className={classNames("relative inline-flex", className)}>
      {children}
      {shouldShow && (
        <span
          className={classNames(
            "absolute -top-2 -right-2 min-w-[20px] h-5 px-1 flex items-center justify-center text-xs font-semibold rounded-full transition-all duration-200",
            variantStyles[variant] || variantStyles.primary,
            badgeClassName
          )}
        >
          {count > maxCount ? `${maxCount}+` : count}
        </span>
      )}
    </div>
  );
};

Badge.propTypes = {
  count: PropTypes.number,
  children: PropTypes.any,
  variant: PropTypes.oneOf([
    "primary",
    "secondary",
    "success",
    "danger",
    "warning",
    "outline",
  ]),
  maxCount: PropTypes.number,
  showZero: PropTypes.bool,
  className: PropTypes.string,
  badgeClassName: PropTypes.string,
};

export default Badge;
